import FACTORY, { factoryModel } from '../../FACTORY/FACTORY.js';
import THEAD from '../../DOM/table/TGROUP/THEAD.js';
import TBODY from '../../DOM/table/TGROUP/TBODY.js';
import TFOOT from '../../DOM/table/TGROUP/TFOOT.js';
/** A Table Group Factory */
export default class TGROUPFACTORY extends FACTORY {
    /** Represents the location where children of this factory are instantiated */
    surrogate;
    constructor(model, surrogate) {
        super(model);
        this.surrogate = surrogate;
        this.addConstructor('THEAD', (model) => this.surrogate.addChild(new THEAD(this.surrogate, model)));
        this.addConstructor('TBODY', (model) => this.surrogate.addChild(new TBODY(this.surrogate, model)));
        this.addConstructor('TFOOT', (model) => this.surrogate.addChild(new TFOOT(this.surrogate, model)));
    }
}
export { factoryModel };
